import React, { useEffect } from "react";
import { useState } from "react";
import { Add, Remove, Upload } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ApiGetClientEntities,
  ApiGetClientEntityByClientGroupId,
  ApiGetClients,
  ApiGetShopperRelativeVenues,
  ApiGetShoppersApplication,
  ApiGetVenueList,
  ApiPutUpdateShopperApplicationStatus,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import heic2any from "heic2any";
import { uploadImageBuffer } from "../../../apiService/Core/ApiEndPoint.tsx";
import axios from "axios";

// Define types for our dropdown data
interface Client {
  id: string;
  name: string;
}

interface Business {
  id: string;
  clientId: string;
  name: string;
}

interface Venue {
  id: string;
  clientEntityId: string;
  name: string;
}

interface VenueSelection {
  clientId: string;
  selectedClientId: string;
  clientEntityId: string;
  venueId: string;
  clientsList: any[];
  clientEntityList: any[];
  venueList: any[];
}

const ViewShopperApplication = () => {
  const [gender, setGender] = useState("");
  const [aldiEmployee, setAldiEmployee] = useState("");
  const [bloomsEmployee, setBloomsEmployee] = useState("");
  const [hotelEmployee, setHotelEmployee] = useState("");
  const [dob, setDob] = useState<Date | null>(null);
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [documentImage, setDocumentImage] = useState<string | null>(null);
  const [taxOption, setTaxOption] = useState("");
  const [taxDocument, setTaxDocument] = useState<string | null>(null);
  const [allSelectedVenueIds, setAllSelectedVenueIds] = useState<string>("");
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  const navigate = useNavigate();

  const location = useLocation();
  const { id } = useParams()
  // const shopperDetails = location?.state?.shopperDetails;
  const [shopperDetails, setShopperDetails] = useState<any>([])
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  console.log(Clientlist);

  // Initialize venue selections with proper structure including clients
  const [venueSelections, setVenueSelections] = useState<VenueSelection[]>([
    {
      clientId: "",
      selectedClientId: "",
      clientEntityId: "",
      venueId: "",
      clientsList: [],
      clientEntityList: [],
      venueList: [],
    },
  ]);



  const handleGetShoppers = async () => {
    if (!id) return;
    let queryParams = `?userId=${id}`;
    try {
      const response: any = await ApiGetShoppersApplication(queryParams);
      setShopperDetails(response?.data[0])
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    id && handleGetShoppers()
  }, [id])
  // Venue selection handlers with proper isolation
  const addVenueSelection = () => {
    setVenueSelections([
      ...venueSelections,
      {
        clientId: "",
        selectedClientId: "",
        clientEntityId: "",
        venueId: "",
        clientsList: [],
        clientEntityList: [],
        venueList: [],
      },
    ]);
  };

  const removeVenueSelection = (index: number) => {
    if (venueSelections.length > 1) {
      const updatedSelections = [...venueSelections];
      updatedSelections.splice(index, 1);
      setVenueSelections(updatedSelections);
    }
  };

  const handleClientDbChange = async (index: number, clientId: string) => {
    const updatedSelections = [...venueSelections];
    updatedSelections[index] = {
      ...updatedSelections[index],
      clientId,
      selectedClientId: "",
      clientEntityId: "",
      venueId: "",
      clientsList: [],
      clientEntityList: [],
      venueList: [],
    };

    // Fetch clients for this specific selection
    if (clientId) {
      try {
        const data = `?clientGroup=${clientId}&status=active&offset=0&limit=100`;
        const response: any = await ApiGetClients(data);
        updatedSelections[index].clientsList = response.data || [];
      } catch (error) {
        console.error("Error during API call:", error);
      }
    }

    setVenueSelections(updatedSelections);
  };

  const handleClientChange = async (
    index: number,
    selectedClientId: string
  ) => {
    const updatedSelections = [...venueSelections];
    updatedSelections[index] = {
      ...updatedSelections[index],
      selectedClientId,
      clientEntityId: "",
      venueId: "",
      clientEntityList: [],
      venueList: [],
    };

    // Fetch client entities for this specific selection
    if (selectedClientId) {
      try {
        const data = `?clientId=${selectedClientId}&offset=0&limit=100&clientEntityStatus=active`;
        const response: any = await ApiGetClientEntities(data);
        console.log("clientEntity list", response.data);
        updatedSelections[index].clientEntityList =
          response.data.map((clientEntity: any) => ({
            label: clientEntity.entityName,
            value: clientEntity.clientEntityId,
            clientEntityId: clientEntity.clientEntityId,
            entityName: clientEntity.entityName,
          })) || [];
      } catch (error) {
        console.error("Error during API call:", error);
      }
    }

    setVenueSelections(updatedSelections);
  };
  console.log(venueSelections);

  const handleBusinessChange = async (
    index: number,
    clientEntityId: string
  ) => {
    const updatedSelections = [...venueSelections];
    updatedSelections[index] = {
      ...updatedSelections[index],
      clientEntityId,
      venueId: "",
      venueList: [],
    };

    // Fetch venues for this specific selection
    if (clientEntityId) {
      try {
        const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500&venueStatus=active`;
        const res = await ApiGetVenueList(data);
        const venueOptions =
          res?.data?.map((item: any) => ({
            label: item.venueName,
            value: item.venueId,
          })) || [];
        updatedSelections[index].venueList = venueOptions;
      } catch (error) {
        console.error("Error fetching venues:", error);
      }
    }

    setVenueSelections(updatedSelections);
  };

  const handleVenueChange = (index: number, venueId: string) => {
    const updatedSelections = [...venueSelections];
    updatedSelections[index].venueId = venueId;
    setVenueSelections(updatedSelections);

    // Update comma-separated venue ID list
    const selectedVenueIds = updatedSelections
      .map((selection) => selection.venueId)
      .filter((id) => id); // remove empty values

    setAllSelectedVenueIds(selectedVenueIds.join(","));
  };
  console.log(allSelectedVenueIds);

  // Get all selected venue IDs
  const getSelectedVenueIds = () => {
    return venueSelections
      .map((selection) => selection.venueId)
      .filter((id) => id);
  };

  // Function to prepopulate venue selections from relative venues data
  const prepopulateVenueSelections = async (relativeVenues: any[]) => {
    if (!relativeVenues || relativeVenues.length === 0) return;

    const prepopulatedSelections: VenueSelection[] = [];

    for (const venue of relativeVenues) {
      try {
        // Find the client group from Clientlist using clientId
        const clientGroup = Clientlist.find(
          (client) =>
            client.id === venue.clientId || client.clientId === venue.clientId
        );

        let clientsListById: any[] = [];
        let clientEntityList: any[] = [];
        let venueList: any[] = [];
        let clientsList: any[] = [];

        // Fetch clients for this clientId
        if (venue.clientId) {
          try {
            const clientsData = `?clientId=${venue.clientId}&status=active&offset=0&limit=100`;
            const clientsResponse: any = await ApiGetClients(clientsData);
            clientsListById = clientsResponse.data || [];
            console.log("client dbname", clientsListById);
          } catch (error) {
            console.error("Error fetching clients:", error);
          }
        }

        // Fetch client entities
        if (venue.clientId) {
          try {
            const entitiesData = `?clientId=${venue.clientId}&offset=0&limit=100&clientEntityStatus=active`;
            const entitiesResponse: any = await ApiGetClientEntities(
              entitiesData
            );
            clientEntityList =
              entitiesResponse.data.map((clientEntity: any) => ({
                label: clientEntity.entityName,
                value: clientEntity.clientEntityId,
                clientEntityId: clientEntity.clientEntityId,
                entityName: clientEntity.entityName,
              })) || [];
          } catch (error) {
            console.error("Error fetching client entities:", error);
          }
        }

        // Fetch venues
        if (venue.clientEntityId) {
          try {
            const venuesData = `?clientEntityId=${venue.clientEntityId}&offset=0&limit=500`;
            const venuesResponse = await ApiGetVenueList(venuesData);
            venueList =
              venuesResponse?.data?.map((item: any) => ({
                label: item.venueName,
                value: item.venueId,
              })) || [];
          } catch (error) {
            console.error("Error fetching venues:", error);
          }
        }

        try {
          const clientsData = `?clientGroup=${clientsListById[0].ClientGroupName.clientGroupName}&status=active&offset=0&limit=100`;
          const clientsResponse: any = await ApiGetClients(clientsData);
          clientsList = clientsResponse.data || [];
          console.log("client dbname", clientsList);
        } catch (error) {
          console.error("Error fetching clients:", error);
        }

        prepopulatedSelections.push({
          clientId: clientsListById[0].ClientGroupName.clientGroupName,
          selectedClientId: venue.clientId.toString(),
          clientEntityId: venue.clientEntityId.toString(),
          venueId: venue.venueId.toString(),
          clientsList,
          clientEntityList,
          venueList,
        });
      } catch (error) {
        console.error("Error prepopulating venue selection:", error);
      }
    }

    if (prepopulatedSelections.length > 0) {
      setVenueSelections(prepopulatedSelections);

      // Update the selected venue IDs string
      const selectedVenueIds = prepopulatedSelections
        .map((selection) => selection.venueId)
        .filter((id) => id);
      setAllSelectedVenueIds(selectedVenueIds.join(","));
    }
  };

  useEffect(() => {
    const fetchShoppeDetails = async () => {
      const data = `/${id}`;

      try {
        const data = `?userId=${id}`;
        const relativeVenueResponse = await ApiGetShopperRelativeVenues(data);
        console.log("relative venues", relativeVenueResponse);

        // Prepopulate venue selections if data exists
        if (
          relativeVenueResponse?.data &&
          relativeVenueResponse.data.length > 0
        ) {
          await prepopulateVenueSelections(relativeVenueResponse.data);
        }
      } catch (err) {
        console.error("Error fetching additional info:", err);
      }
    };
    fetchShoppeDetails();
  }, [id]);

  const handleProfileImageUpload = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfileImage(e.target?.result as string);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleDocumentUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setDocumentImage(e.target?.result as string);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleTaxDocumentUpload = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setTaxDocument(e.target?.result as string);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const updateApplicationStatus = async (shopper: any, updatedStatus: any) => {
    const data = {
      userId: shopper.userId,
      status: updatedStatus,
      ...(rejectReason?.length > 0 && { rejectReason })
    };
    const response: any = await ApiPutUpdateShopperApplicationStatus(data);
    toast.success("Application Status updated successfully");
    navigate(-1);
  };

  // Custom styles to override external CSS
  const formStyles = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      borderRadius: "10px",
      padding: "20px",
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#fff",
    },
    section: {
      marginBottom: "30px",
      borderBottom: "1px solid #f0f0f0",
      paddingBottom: "20px",
    },
    sectionTitle: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
    },
    sectionNumber: {
      marginRight: "8px",
    },
    sectionDescription: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "15px",
    },
    formRow: {
      display: "flex",
      flexWrap: "wrap",
      margin: "0 -10px",
      marginBottom: "15px",
    },
    formColumn: {
      flex: "1 0 calc(50% - 20px)",
      margin: "0 10px",
      minWidth: "250px",
    },
    formColumnFull: {
      flex: "1 0 calc(100% - 20px)",
      margin: "0 10px",
    },
    formColumnThird: {
      flex: "1 0 calc(33.333% - 20px)",
      margin: "0 10px",
      minWidth: "200px",
    },
    formColumnQuarter: {
      flex: "1 0 calc(25% - 20px)",
      margin: "0 10px",
      minWidth: "180px",
    },
    inputLabel: {
      display: "block",
      fontSize: "14px",
      marginBottom: "5px",
      color: "#333",
    },
    requiredStar: {
      color: "red",
      marginLeft: "2px",
    },
    textField: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
    },
    radioGroup: {
      display: "flex",
      alignItems: "center",
      marginTop: "5px",
    },
    radioLabel: {
      marginRight: "20px",
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
    },
    radioInput: {
      marginRight: "5px",
      width: "16px",
      height: "16px",
      accentColor: "#1976d2",
      cursor: "pointer",
    },
    uploadBox: {
      border: "1px dashed #ccc",
      borderRadius: "4px",
      height: "200px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      width: "50%",
      position: "relative" as const,
    },
    uploadIcon: {
      fontSize: "24px",
      color: "#666",
      marginBottom: "8px",
    },
    uploadText: {
      fontSize: "14px",
      color: "#666",
    },
    textareaField: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "14px",
      minHeight: "100px",
      boxSizing: "border-box",
      resize: "vertical",
    },
    wordCount: {
      fontSize: "12px",
      color: "#666",
      textAlign: "right",
      marginTop: "5px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
      marginTop: "20px",
    },
    button: {
      padding: "10px 20px",
      backgroundColor: "#1976d2",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "bold",
    },
    otherDetailsContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "15px",
      marginBottom: "20px",
    },
    otherDetailsItem: {
      flex: "1 0 200px",
      minWidth: "200px",
    },
    questionContainer: {
      marginBottom: "10px",
    },
    fileInput: {
      position: "absolute" as const,
      width: "100%",
      height: "100%",
      opacity: 0,
      cursor: "pointer",
    },
    // Clean dropdown styles matching the image design
    dropdownContainer: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      marginBottom: "15px",
      flexWrap: "wrap",
    },
    dropdown: {
      width: "200px",
      height: "45px",
      padding: "0 15px",
      border: "1px solid #d1d5db",
      borderRadius: "8px",
      fontSize: "14px",
      color: "#6b7280",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: "right 12px center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "16px",
      transition: "border-color 0.15s ease-in-out",
    },
    dropdownFocus: {
      borderColor: "#3b82f6",
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
    },
    iconButton: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      transition: "all 0.2s ease",
    },
    addButton: {
      backgroundColor: "#10b981",
      color: "white",
      "&:hover": {
        backgroundColor: "#059669",
      },
    },
    removeButton: {
      backgroundColor: "#ef4444",
      color: "white",
      "&:hover": {
        backgroundColor: "#dc2626",
      },
    },
  };

  const isPDF = (url: string) => {
    return url?.toLowerCase().endsWith(".pdf");
  };


    function parseS3Url(url: string) {
    const parsed = new URL(url);
    const parts = parsed.pathname.split("/").filter(Boolean);
    const bucket = parts[0];
    let key = parts.slice(1).join("/");
    key = key.replace(/\u202f/g, " ");
    return { bucket, key };
  }


  
  const getDisplayUrl = async (url: string) => {
    try {
      const isHeic =
        url.toLowerCase().endsWith(".heic") ||
        url.toLowerCase().endsWith(".heif");

      // Non-HEIC: just proxy through your existing backend endpoint
      if (!isHeic) {
        const { bucket, key } = parseS3Url(url);
        const res = await axios.get(
          `${uploadImageBuffer}?bucket=${encodeURIComponent(bucket)}&key=${encodeURIComponent(key)}`,
          { responseType: "blob" }
        );
        return URL.createObjectURL(res.data);
      }

      // HEIC: proxy first, then convert
      const { bucket, key } = parseS3Url(url);
      const res = await axios.get(
        `${uploadImageBuffer}?bucket=${encodeURIComponent(bucket)}&key=${encodeURIComponent(key)}`,
        { responseType: "blob" }
      );

      const convertedBlob = await heic2any({
        blob: res.data,
        toType: "image/jpeg",
        quality: 0.9,
      });

      return URL.createObjectURL(convertedBlob as Blob);
    } catch (error) {
      console.error("Error loading image:", error);
      return url; // fallback to original URL
    }
  };

  const [licenceUrl, setlicenceUrl] = useState("");
  const [profileImageUrl, setProfileImageUrl] = useState("");

  useEffect(() => {
    if (!shopperDetails?.driving_licence) return;

    getDisplayUrl(shopperDetails.driving_licence).then(setlicenceUrl);
  }, [shopperDetails?.driving_licence]);


  useEffect(() => {
    if (!shopperDetails?.profilePicUrl) return;

    getDisplayUrl(shopperDetails?.profilePicUrl).then(setProfileImageUrl);
  }, [shopperDetails?.profilePicUrl]);

  return (
    <div className="w-100 p-2">
      <div style={formStyles.container}>
        {/* Personal Details Section */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>1.</span> Personal Details
          </div>
          <div style={formStyles.sectionDescription}>
            Tell us a little about yourself.
          </div>

          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ flex: "1 1 65%", paddingRight: "20px" }}>
              <div style={formStyles.formRow}>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    First Name <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    style={formStyles.textField}
                    value={shopperDetails?.firstName || ""}
                    disabled
                  />
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Last Name <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    style={formStyles.textField}
                    value={shopperDetails?.lastName || ""}
                    disabled
                  />
                </div>
              </div>

              <div style={formStyles.formRow}>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Email <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="email"
                    style={formStyles.textField}
                    value={shopperDetails?.emailId || ""}
                    disabled
                  />
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Mobile <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    style={formStyles.textField}
                    value={shopperDetails?.contactNo || ""}
                    disabled
                  />
                </div>
              </div>

              <div style={formStyles.formRow}>
                <div style={formStyles.formColumnFull}>
                  <label style={formStyles.inputLabel}>
                    Address <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    style={formStyles.textField}
                    value={`${shopperDetails?.address} ${shopperDetails?.city ? shopperDetails?.city : ''} ${shopperDetails?.state}, ${shopperDetails?.country}` || ""}
                    disabled
                  />
                </div>
              </div>

              <div style={formStyles.formRow}>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Suburb <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    style={formStyles.textField}
                    value={shopperDetails?.city || ""}
                    disabled
                  />
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    State <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    style={formStyles.textField}
                    value={shopperDetails?.state || ""}
                    disabled
                  />
                </div>
              </div>

              <div style={formStyles.formRow}>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    D.O.B <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    style={formStyles.textField}
                    value={
                      shopperDetails?.dob
                        ? new Date(shopperDetails.dob).toLocaleDateString()
                        : ""
                    }
                    disabled
                  />
                </div>
                <div style={formStyles.formRow}>
                  <div style={formStyles.formColumn}>
                    <label style={formStyles.inputLabel}>
                      Age <span style={formStyles.requiredStar}>*</span>
                    </label>
                    <input
                      type="text"
                      style={formStyles.textField}
                      value={
                        shopperDetails?.dob
                          ? (() => {
                            const dob = new Date(shopperDetails.dob);
                            const diff = Date.now() - dob.getTime();
                            const ageDate = new Date(diff);
                            return Math.abs(ageDate.getUTCFullYear() - 1970);
                          })()
                          : ""
                      }
                      disabled
                    />
                  </div>
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Gender <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <div style={formStyles.radioGroup}>
                    <label style={formStyles.radioLabel}>
                      <input
                        type="radio"
                        style={formStyles.radioInput}
                        checked={shopperDetails?.gender === "Male"}
                        disabled
                      />
                      Male
                    </label>
                    <label style={formStyles.radioLabel}>
                      <input
                        type="radio"
                        style={formStyles.radioInput}
                        checked={shopperDetails?.gender === "Female"}
                        disabled
                      />
                      Female
                    </label>
                  </div>
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Postcode <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    style={formStyles.textField}
                    value={shopperDetails?.postalCode || ""}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div style={{ flex: "1 1 35%" }}>
              <label style={formStyles.inputLabel}>
                Profile Image <span style={formStyles.requiredStar}>*</span>
              </label>
              <div style={formStyles.uploadBox}>
                {shopperDetails?.profilePicUrl ? (
                  <img
                    src={profileImageUrl || "/placeholder.svg"}
                    alt="Profile"
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <>
                    <div style={formStyles.uploadIcon}>
                      <Upload />
                    </div>
                    <div style={formStyles.uploadText}>Upload Here</div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Other Details Section - Redesigned to show all fields in a single row */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>2.</span> Other Details
          </div>
          <div style={formStyles.sectionDescription}>
            These details help us match you to the right tasks
          </div>

          <div style={formStyles.otherDetailsContainer}>
            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Do you or an immediate family member or close friend work for
                  ALDI? <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={shopperDetails?.workForAldi === true}
                      disabled
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={shopperDetails?.workForAldi === false}
                      disabled
                    />
                    NO
                  </label>
                </div>
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Do you or an immediate family member or close friend work for
                  BLOOMS the Chemist?{" "}
                  <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={shopperDetails?.workForBlooms === true}
                      disabled
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={shopperDetails?.workForBlooms === false}
                      disabled
                    />
                    No
                  </label>
                </div>
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Do you or an immediate family member or close friend work for a
                  hotel/pub chain? <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={shopperDetails?.workForHotelpub === true}
                      disabled
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={shopperDetails?.workForHotelpub === false}
                      disabled
                    />
                    No
                  </label>
                </div>
              </div>
              {shopperDetails?.workForHotelpub === true && (
                <div style={formStyles.formRow}>
                  <div style={formStyles.formColumnFull}>
                    <label style={formStyles.inputLabel}>Hotel/Pub Name</label>
                    <input
                      type="text"
                      style={formStyles.textField}
                      value={shopperDetails?.hotelPubName || ""}
                      disabled
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Fixed Venue Selection Dropdowns with proper isolation */}
          {shopperDetails.workForHotelpub === true && (
            <div style={formStyles.formRow}>
              <div style={formStyles.formColumnFull}>
                <label style={formStyles.inputLabel}>
                  Select Sites <span style={formStyles.requiredStar}>*</span>
                </label>

                {venueSelections.map((selection, index) => (
                  <div key={index} style={formStyles.dropdownContainer}>
                    {/* Client DBName Dropdown */}
                    <select
                      value={selection.clientId}
                      onChange={(e) =>
                        handleClientDbChange(index, e.target.value)
                      }
                      style={formStyles.dropdown}
                      disabled
                    >
                      <option value="">Select DBName</option>
                      {Clientlist.map((client) => (
                        <option key={client.id} value={client.id}>
                          {client.clientGroupName}
                        </option>
                      ))}
                    </select>

                    {/* NEW: Client Dropdown - only shown if DBName is selected */}
                    {selection.clientId && selection.clientsList.length > 0 && (
                      <select
                        value={selection.selectedClientId}
                        onChange={(e) =>
                          handleClientChange(index, e.target.value)
                        }
                        style={formStyles.dropdown}
                        disabled
                      >
                        <option value="">Select Client</option>
                        {selection.clientsList.map((client) => (
                          <option key={client.ClientID} value={client.ClientID}>
                            {client.ClientName}
                          </option>
                        ))}
                      </select>
                    )}

                    {/* Business Dropdown - only shown if client is selected */}
                    {selection.selectedClientId &&
                      selection.clientEntityList.length > 0 && (
                        <select
                          value={selection.clientEntityId}
                          onChange={(e) =>
                            handleBusinessChange(index, e.target.value)
                          }
                          style={formStyles.dropdown}
                          disabled
                        >
                          <option value="">Select Business</option>
                          {selection.clientEntityList
                            ?.filter((item) => item.clientEntityId !== null)
                            .map((business) => (
                              <option
                                key={business.clientEntityId}
                                value={business.clientEntityId}
                              >
                                {business.entityName}
                              </option>
                            ))}
                        </select>
                      )}

                    {/* Venue Dropdown - only shown if business is selected */}
                    {selection.clientEntityId &&
                      selection.venueList.length > 0 && (
                        <select
                          value={selection.venueId}
                          onChange={(e) =>
                            handleVenueChange(index, e.target.value)
                          }
                          style={formStyles.dropdown}
                          disabled
                        >
                          <option value="">Search Site</option>
                          {selection.venueList.map((venue: any) => (
                            <option key={venue.value} value={venue.value}>
                              {venue.label}
                            </option>
                          ))}
                        </select>
                      )}

                    {/* Add/Remove buttons with MUI icons */}
                    {index === venueSelections.length - 1 && (
                      <button
                        type="button"
                        onClick={addVenueSelection}
                        style={{
                          ...formStyles.iconButton,
                          ...formStyles.addButton,
                        }}
                        title="Add venue selection"
                      >
                        <Add />
                      </button>
                    )}

                    {venueSelections.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeVenueSelection(index)}
                        style={{
                          ...formStyles.iconButton,
                          ...formStyles.removeButton,
                        }}
                        title="Remove venue selection"
                      >
                        <Remove />
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={formStyles.otherDetailsContainer}>
            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Are you prepared to buy alcohol?{" "}
                  <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={
                        shopperDetails?.shopperOtherDetails?.[0]
                          ?.isShopperBuyAlcohol === true
                      }
                      disabled
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={
                        shopperDetails?.shopperOtherDetails?.[0]
                          ?.isShopperBuyAlcohol === false
                      }
                      disabled
                    />
                    NO
                  </label>
                </div>
              </div>
            </div>
            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Are you prepared to go into the smoking area?{" "}
                  <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={
                        shopperDetails?.shopperOtherDetails?.[0]
                          ?.isShopperCanVisitSmokingArea === true
                      }
                      disabled
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={
                        shopperDetails?.shopperOtherDetails?.[0]
                          ?.isShopperCanVisitSmokingArea === false
                      }
                      disabled
                    />
                    NO
                  </label>
                </div>
              </div>
            </div>
            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Are you prepared to gamble?{" "}
                  <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={
                        shopperDetails?.shopperOtherDetails?.[0]
                          ?.isShopperCanDoGambling === true
                      }
                      disabled
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      style={formStyles.radioInput}
                      checked={
                        shopperDetails?.shopperOtherDetails?.[0]
                          ?.isShopperCanDoGambling === false
                      }
                      disabled
                    />
                    NO
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Document Details Section */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>3.</span> Document Details
          </div>
          <div style={formStyles.sectionDescription}>
            Upload documents for verification.
          </div>

          <div style={formStyles.formRow}>
            <div style={formStyles.formColumnFull}>
              <label style={formStyles.inputLabel}>
                Add your Driver's License or Photo ID here{" "}
                <span style={formStyles.requiredStar}>*</span>
              </label>
              <div style={{ ...formStyles.uploadBox, height: "150px" }}>
                {shopperDetails?.driving_licence ?
                  isPDF(shopperDetails?.driving_licence) ? (
                    <iframe
                      src={`${shopperDetails?.driving_licence}#toolbar=0`}
                      title="PDF Preview"
                      width="100%"
                      height="100%"
                      style={{ border: "none", borderRadius: "8px" }}
                    />
                  ) : (
                    <img
                      // src={getDisplayUrl(shopperDetails?.driving_licence)}
                      src={licenceUrl}
                      alt="Uploaded preview"
                      width="100%"
                      height="100%"
                      style={{ objectFit: "contain", borderRadius: "8px" }}
                    />

                  )
                  // (
                  //   <img
                  //     src={shopperDetails.driving_licence || "/placeholder.svg"}
                  //     alt="Document"
                  //     style={{
                  //       maxHeight: "100%",
                  //       maxWidth: "100%",
                  //       objectFit: "contain",
                  //     }}
                  //   />
                  // ) 
                  : (
                    <>
                      <div style={formStyles.uploadIcon}>
                        <Upload />
                      </div>
                      <div style={formStyles.uploadText}>Capture/Upload Here</div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>

        {/* Write a Review Section */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>4.</span> Shopper Application
          </div>
          <div style={formStyles.sectionDescription}>
            Final step: submit your application
          </div>
          <div style={formStyles.formRow}>
            <div style={formStyles.formColumnFull}>
              <label style={formStyles.inputLabel}>
                Please write a 150-200-character review of a recent customer
                service experience you have had at a store, restaurant or hotel.
                This should be fact-based{" "}
                <span style={formStyles.requiredStar}>*</span>
              </label>
              <textarea
                style={formStyles.textareaField}
                rows={5}
                value={
                  shopperDetails?.shopperOtherDetails?.[0]?.shoppperDetail || ""
                }
                disabled
              ></textarea>
              <div style={formStyles.wordCount}>
                Words:{" "}
                {shopperDetails?.shopperOtherDetails?.[0]?.shoppperDetail
                  ?.split(/\s+/)
                  .filter(Boolean).length || 0}
              </div>
            </div>
          </div>
        </div>

        <div style={formStyles.buttonContainer}>
          <Button
            variant="contained"
            className="table-row-background"
            //style={formStyles.button}
            onClick={() => updateApplicationStatus(shopperDetails, "approve")}
          >
            Approve
          </Button>
          <Button
            variant="contained"
            className="table-row-background"
            //style={formStyles.button}
            // onClick={() => updateApplicationStatus(shopperDetails, "reject")}
            onClick={() => {
              setOpenRejectDialog(true);
            }}
          //style={{ ...formStyles.button, backgroundColor: "#d32f2f" }}
          >
            Reject
          </Button>
        </div>
      </div>
      <Dialog open={openRejectDialog} onClose={() => setOpenRejectDialog(false)}>
        <DialogTitle>Select Reject Reason</DialogTitle>
        <DialogContent>
          <RadioGroup
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
          >
            <FormControlLabel value="Invalid ID" control={<Radio />} label="Invalid ID" />
            <FormControlLabel value="Not Following Instructions" control={<Radio />} label="Not Following Instructions" />
            <FormControlLabel value="Spelling/Grammer" control={<Radio />} label="Spelling/Grammer" />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenRejectDialog(false); setRejectReason("") }} >Cancel</Button>
          <Button
            variant="contained"
            sx={{ background: "#ADB792" }}
            disabled={!rejectReason}
            onClick={async () => {
              if (!shopperDetails) return;
              await updateApplicationStatus(shopperDetails, "reject");
              setOpenRejectDialog(false);
              setRejectReason("");
            }}
          >
            Confirm Reject
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ViewShopperApplication;
